import React from "react";
import withSizePositionAngle from "components/withSizePositionAngle";


const _MotionBlur = () => {

    return (
        <g transform="translate(-79.011856 -122.556600)">
          <g><path fill="none" stroke="#cccccc" strokeWidth="1.32292" strokeLinecap="round" strokeLinejoin="miter" strokeDasharray="none" strokeOpacity="1" d="M 254.93798,122.5566 H 147.11236"/><path fill="none" stroke="#cccccc" strokeWidth="1.32292" strokeLinecap="round" strokeLinejoin="miter" strokeDasharray="none" strokeOpacity="1" d="m 232.27462,152.58718 -153.262764,0.0562"/><path fill="none" stroke="#cccccc" strokeWidth="1.32292" strokeLinecap="round" strokeLinejoin="miter" strokeDasharray="none" strokeOpacity="1" d="M 255.35056,173.60591 H 154.09499"/></g>
        </g>
    );
}

const MotionBlur = withSizePositionAngle(_MotionBlur, 176.338704, 51.049310);

export default MotionBlur;